import {Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, signal} from '@angular/core';
import {AppPerformanceTrackers, PerformanceTracker} from '../../../lib/performance';
import {sortBy} from 'es-toolkit';
import {DecimalPipe} from '@angular/common';

@Component({
    selector: 'app-app-devtools-performance',
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        DecimalPipe
    ],
    templateUrl: './app-devtools-performance.component.html',
    styleUrl: './app-devtools-performance.component.scss',
})
export class AppDevtoolsPerformanceComponent implements OnInit {

    protected readonly trackers = signal<PerformanceTracker[]>([]);

    constructor() {
    }

    ngOnInit() {
        const trackers = sortBy(Object.values(AppPerformanceTrackers.trackerRegistry), ['name']);
        this.trackers.set(trackers);
    }
}
